var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-xs text-center text-white bg-hy-darkblue"},[_c('p',{staticClass:"py-4"},[_vm._v(" Website maintained by Activa Media. All Rights Reserved. ")])])])
}]

export { render, staticRenderFns }